import { USER_INVITED } from './types'

function setUserInvited(isUserInvited) {
    return (dispatch) => {
        dispatch({
            type: USER_INVITED,
            payload: isUserInvited
        });
    }
}

export default setUserInvited;